import { render, staticRenderFns } from "./OutboundManagement.vue?vue&type=template&id=b1a4afca&scoped=true"
import script from "./OutboundManagement.vue?vue&type=script&lang=js"
export * from "./OutboundManagement.vue?vue&type=script&lang=js"
import style0 from "./OutboundManagement.vue?vue&type=style&index=0&id=b1a4afca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a4afca",
  null
  
)

export default component.exports